export default function getIsCouncilAdmin(state: any) {
  return state.getIn(['currentUser', 'data', 'isCouncilAdmin'], false);
}
